import { useGewaehltName, usePersonAnsicht } from "./personAnsicht";
import { ANSICHT_TEXTE } from "./saetze";

/** W82 Web-5f (F1 = A, H3), herausgelöst in Web-5h1 (F1 = C, D-624): solange eine Person gewählt ist, sagt eine leise Zeile,
 *  welche (Z17); „Alle zeigen“ hebt sie auf, der Fokus geht danach auf die Überschrift der Seite. Startseite und Reiter Fristen. */
export function AnsichtZeile() {
  const { setPerson } = usePersonAnsicht();
  const name = useGewaehltName();
  if (!name) return null;
  return (
    <p className="ansicht-zeile" data-testid="ansicht-zeile">
      <span className="ansicht-text">{ANSICHT_TEXTE.zeile(name)}</span>
      <button
        type="button"
        className="ansicht-knopf"
        onClick={() => {
          setPerson("alle");
          document.querySelector<HTMLElement>("main h1")?.focus({ preventScroll: true });
        }}
      >
        {ANSICHT_TEXTE.alle}
      </button>
    </p>
  );
}
